import { showToast } from "@utils/helper/index.helper";
import React, { useRef } from "react";
import ReactDOM from "react-dom";
import Draggable from "react-draggable";

const FloatingClearCache: React.FC = () => {
  const portalRoot = document.getElementById("floating-root");
  const nodeRef = useRef<HTMLDivElement>(null); // 👈 ref to element

  const handleClearCache = async () => {
    try {
      await fetch("https://skillshikshya.com/api/clear-cache", {
        method: "GET",
        mode: "no-cors",
      });

      showToast({
        title: "Cache Clear",
        description: "Cache cleared successfully",
        type: "success",
      });
    } catch (error) {
      showToast({
        title: "Error",
        description: "Failed to clear cache",
        type: "error",
      });
    }
  };

  if (!portalRoot) return null;

  return ReactDOM.createPortal(
    <Draggable
      nodeRef={nodeRef}
      defaultPosition={{ x: 0, y: 0 }}
      cancel="button" // 👈 Prevent dragging when clicking the button
    >
      <div
        ref={nodeRef} // 👈 attach ref here
        className="fixed bottom-6 right-6 z-[9999] cursor-grab p-3" // 👈 Added p-3 for larger drag area
        style={{ width: "fit-content" }}
      >
        <button
          onClick={handleClearCache} // 👈 Fixed: removed arrow function wrapper
          className="px-4 py-4 rounded-full bg-gray-800 text-white shadow-lg hover:bg-green-600 transition cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-broom-icon lucide-broom"
          >
            <path d="m13 11 9-9" />
            <path d="M14.6 12.6c.8.8.9 2.1.2 3L10 22l-8-8 6.4-4.8c.9-.7 2.2-.6 3 .2Z" />
            <path d="m6.8 10.4 6.8 6.8" />
            <path d="m5 17 1.4-1.4" />
          </svg>
        </button>
      </div>
    </Draggable>,
    portalRoot
  );
};

export default FloatingClearCache;
